export const USER_SUBJECTID_DETAIL =
    'User has not logged in yet, Subject ID will be filled up once user logs in to the system';